var cifSe = ["301 189", "<g fill='none'><path fill='#005293' d='M.5.75h300v187.5H.5z'/><path fill='#FECB00' d='M94.25.75h37.5v187.5h-37.5z'/><path fill='#FECB00' d='M.5 75.75h300v37.5H.5z'/></g>"];

export { cifSe };

